import { useState, useEffect, useRef } from "react";
const testimonials = [
  { quote: "Literally changed my life. I used to spend hours waiting at the dealership. Now I just book through the app and they come to my office while I'm working.", name: "Sarah Jenkins", car: "Tesla Model 3 Owner" },
  { quote: "The transparent pricing is a game changer. No hidden fees or 'extra' repairs I didn't ask for. The mechanic was incredibly professional and explained everything.", name: "David Miller", car: "BMW M4 Owner" },
  { quote: "I'm a car enthusiast, and I'm very picky about who touches my vehicle. Fuelingo's detailing pros are top-tier. Best ceramic coating I've ever had.", name: "Alex Rivera", car: "Porsche 911 Owner" },
  { quote: "Literally changed my life. I used to spend hours waiting at the dealership. Now I just book through the app and they come to my office while I'm working.", name: "Sarah Jenkins", car: "Tesla Model 3 Owner" },
  { quote: "The transparent pricing is a game changer. No hidden fees or 'extra' repairs I didn't ask for. The mechanic was incredibly professional and explained everything.", name: "David Miller", car: "BMW M4 Owner" },
  { quote: "I'm a car enthusiast, and I'm very picky about who touches my vehicle. Fuelingo's detailing pros are top-tier. Best ceramic coating I've ever had.", name: "Alex Rivera", car: "Porsche 911 Owner" },
];

function ConstellationCanvas() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let particles = [];
    let animationFrameId;

    const resize = () => {
      const dpr = window.devicePixelRatio || 1;
      const rect = canvas.parentElement.getBoundingClientRect();
      canvas.width = rect.width * dpr;
      canvas.height = rect.height * dpr;
      canvas.style.width = `${rect.width}px`;
      canvas.style.height = `${rect.height}px`;
      ctx.scale(dpr, dpr);
      return rect;
    };

    class Particle {
      constructor(w, h) {
        this.x = Math.random() * w;
        this.y = Math.random() * h;
        this.vx = (Math.random() - 0.5) * 0.3;
        this.vy = (Math.random() - 0.5) * 0.3;
        this.r = Math.random() > 0.7 ? Math.random() * 3 + 2 : Math.random() * 1.5 + 0.5;
      }
      draw() {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.r, 0, Math.PI * 2);
        ctx.fillStyle = "rgba(234, 53, 43, 0.8)"; 
        ctx.fill();
      }
      update(w, h) {
        this.x += this.vx;
        this.y += this.vy;
        if (this.x < 0 || this.x > w) this.vx *= -1;
        if (this.y < 0 || this.y > h) this.vy *= -1;
      }
    }

    const init = () => {
      const rect = resize();
      const count = window.innerWidth < 768 ? 60 : 130;
      particles = [];
      for (let i = 0; i < count; i++) {
        particles.push(new Particle(rect.width, rect.height));
      }
    };

    const animate = () => {
      const rect = canvas.getBoundingClientRect();
      ctx.clearRect(0, 0, rect.width, rect.height);
      particles.forEach((p, i) => {
        p.update(rect.width, rect.height);
        p.draw();
        for (let j = i + 1; j < particles.length; j++) {
          const dx = p.x - particles[j].x;
          const dy = p.y - particles[j].y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < 130) {
            ctx.beginPath();
            ctx.moveTo(p.x, p.y);
            ctx.lineTo(particles[j].x, particles[j].y);
            ctx.strokeStyle = `rgba(234, 53, 43, ${0.25 * (1 - dist / 130)})`;
            ctx.lineWidth = 0.5;
            ctx.stroke();
          }
        }
      });
      animationFrameId = requestAnimationFrame(animate);
    };

    init();
    animate();
    window.addEventListener("resize", init);
    return () => {
      window.removeEventListener("resize", init);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return <canvas ref={canvasRef} style={{ position: "absolute", inset: 0, width: "100%", height: "100%", zIndex: 0, pointerEvents: "none" }} />;
}

export default function Testimonials() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section className="testimonials-section">
      <ConstellationCanvas />
      
      {/* Background Stoke Lines */}
      <div className="grid-lines">
        <div className="v-line l-left"></div>
        <div className="v-line l-right"></div>
      </div>

      <div className="container">
        {/* Badge */}
        <div className="badge-wrapper">
          <span className="testimonial-badge">Testimonials</span>
        </div>

        {/* Heading */}
        <h2 className="heading-main">Trusted By 5,000+ Car Owners.</h2>

        {/* Testimonials Grid - No Entrance Animation to prevent rendering lag */}
        <div className="testimonials-grid">
          {testimonials.map((t, i) => (
            <div key={i} className="testimonial-card">
              <p className="quote">"{t.quote}"</p>
              <div className="user-info">
                <div className="avatar">
                  {t.name.split(" ").map(n => n[0]).join("")}
                </div>
                <div className="user-details">
                  <span className="user-name">{t.name}</span>
                  <span className="user-car">{t.car}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

        .testimonials-section {
          background-color: #ffffff;
          padding: 100px 20px;
          position: relative;
          font-family: 'Inter', sans-serif;
          overflow: hidden;
          display: flex;
          justify-content: center;
        }

        .container {
          width: 100%;
          max-width: 1200px;
          position: relative;
          z-index: 2;
          text-align: center;
        }

        .grid-lines {
          position: absolute;
          inset: 0;
          pointer-events: none;
          z-index: 1;
        }
        .v-line {
          position: absolute;
          top: 0;
          bottom: 0;
          width: 1px;
         
        }
        .l-left { left: 12%; }
        .l-right { right: 12%; }

        .badge-wrapper { margin-bottom: 25px; }
        .testimonial-badge {
          background: #FFFFFF;
          border: 1px solid #E5E7EB;
          padding: 6px 16px;
          border-radius: 30px;
          font-size: 13px;
          color: #6B7280;
          font-weight: 500;
        }

        .heading-main {
          font-size: clamp(30px, 4.2vw, 43px);
          font-weight: 600;
          color: #0F172A;
          letter-spacing: -0.03em;
          margin-bottom: 60px;
        }

        .testimonials-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
        }

        .testimonial-card {
          background: rgba(255, 255, 255, 0.95);
          border: 1px solid #f1f1f1;
          border-radius: 24px;
          padding: 35px 25px;
          text-align: left;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          box-shadow: 0 10px 30px rgba(0,0,0,0.02);
          min-height: 240px;
          transition: transform 0.2s ease;
        }
        .testimonial-card:hover { transform: translateY(-3px); }

        .quote {
          font-size: 15px;
          color: #475569;
          line-height: 1.6;
          margin-bottom: 30px;
        }

        .user-info {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .avatar {
          width: 40px;
          height: 40px;
          background: #F3F4F6;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 12px;
          color: #1F2937;
        }
        .user-details { display: flex; flex-direction: column; }
        .user-name { font-size: 14px; font-weight: 700; color: #111; }
        .user-car { font-size: 12px; color: #9CA3AF; }

        @media (max-width: 991px) {
          .testimonials-grid { grid-template-columns: 1fr; }
          .l-left, .l-right { display: none; }
          .testimonials-section { padding: 60px 16px; }
        }
      `}} />
    </section>
  );
}